import React from 'react';
import clsx from 'clsx';
type SortingIconProps = {
  dir?: 'asc' | 'desc' | 'none';
};
export const SortingIcon = ({ dir = 'none' }: SortingIconProps) => {
  const upArrowClass = clsx(dir === 'desc' ? 'fill-black' : 'fill-spanishGray');
  const downArrowClass = clsx(dir === 'asc' ? 'fill-black' : 'fill-spanishGray');

  return (
    <svg
      width='21'
      height='20'
      viewBox='0 0 21 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        className={upArrowClass}
        d='M6.16063 13.126L9.99992 17.7619C10.0618 17.8366 10.1386 17.8965 10.225 17.9376C10.3113 17.9787 10.4053 18 10.5004 18C10.5954 18 10.6894 17.9787 10.7758 17.9376C10.8622 17.8965 10.9389 17.8366 11.0008 17.7619L14.8401 13.126C15.2065 12.6835 14.9027 12 14.3396 12H6.65998C6.09691 12 5.79313 12.6835 6.16063 13.126Z'
      />
      <path
        className={downArrowClass}
        d='M6.16063 6.874L9.99992 2.23812C10.0618 2.16343 10.1386 2.10348 10.225 2.06238C10.3113 2.02128 10.4053 2 10.5004 2C10.5954 2 10.6894 2.02128 10.7758 2.06238C10.8622 2.10348 10.9389 2.16343 11.0008 2.23812L14.8401 6.874C15.2065 7.3165 14.9027 8 14.3396 8H6.65998C6.09691 8 5.79313 7.3165 6.16063 6.874Z'
      />
    </svg>
  );
};

export default SortingIcon;
